import { Box, Typography, useMediaQuery } from '@mui/material';

import { AUTH_BREAKPOINTS } from './authConstants';

const AuthHeader = ({
  title,
  subtitle,
  description,
  icon: Icon,
  iconColor = '#1976d2'
}) => {
  const isMobile = useMediaQuery(AUTH_BREAKPOINTS.mobile);
  const isTablet = useMediaQuery(AUTH_BREAKPOINTS.tablet);

  return (
    <Box sx={{ textAlign: 'center', mb: { xs: 3, sm: 3, md: 4 } }}>
      {/* Icon */}
      {Icon && (
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
          {typeof Icon === 'string' ? (
            <img
              src={Icon}
              alt='Icon'
              style={{
                height: isMobile ? '80px' : '96px',
                width: 'auto'
              }}
            />
          ) : (
            <Icon
              sx={{
                fontSize: isMobile ? 48 : 64,
                color: iconColor,
                display: 'block',
                mx: 'auto'
              }}
            />
          )}
        </Box>
      )}

      {/* Title */}
      <Typography
        variant={isMobile ? 'h5' : isTablet ? 'h5' : 'h4'}
        component='h2'
        sx={{
          mt: { xs: 0.5, sm: 0.5, md: 0 },
          fontFamily: 'Nunito Sans, sans-serif',
          fontWeight: 700,
          fontSize: { xs: '1.25rem', sm: '1.35rem', md: '2.125rem' },
          color: '#212121',
          mb: subtitle ? 1 : 0
        }}
      >
        {title}
      </Typography>
      {/* Subtitle */}
      {subtitle && (
        <Typography
          variant={isMobile ? 'h6' : 'h5'}
          sx={{
            color: '#212121',
            fontFamily: 'Nunito Sans, sans-serif',
            fontWeight: 600,
            fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' },
            mb: description ? 1 : 0
          }}
        >
          {subtitle}
        </Typography>
      )}

      {/* Description */}
      {description && (
        <Typography
          variant='body1'
          sx={{
            color: '#636363',
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 300,
            fontSize: { xs: '0.9rem', sm: '1rem', md: '1rem' }
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default AuthHeader;
